import api from "@/config/api";
import { handleApiError } from "@/utils/ErrorHandler";

const state = {
    volunteerStats: null,
    loading: false,
    error: null,
};

const mutations = {
    SET_VOLUNTEER_STATS(state, data) {
        state.volunteerStats = data;
    },
    SET_VOLUNTEER_STATS_LOADING(state, val) {
        state.loading = val;
    },
    SET_VOLUNTEER_STATS_ERROR(state, err) {
        state.error = err;
    },
};

const actions = {
    /**
     * Fetch volunteer assignment stats for a location.
     * GET /api/locations/{locationId}/volunteer-stats
     */
    async fetchVolunteerStats({ commit }, { locationId }) {
        commit("SET_VOLUNTEER_STATS_LOADING", true);
        commit("SET_VOLUNTEER_STATS_ERROR", null);

        try {
            const response = await api.get(`/locations/${locationId}/volunteer-stats`);
            const data = response.data?.data || response.data;
            commit("SET_VOLUNTEER_STATS", data);
            return data;
        } catch (error) {
            const message = handleApiError(error, "Failed to fetch volunteer stats");
            commit("SET_VOLUNTEER_STATS_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_VOLUNTEER_STATS_LOADING", false);
        }
    },
};

const getters = {
    volunteerStats: (state) => state.volunteerStats,
    volunteerStatsLoading: (state) => state.loading,
    volunteerStatsError: (state) => state.error,
};

export default {
    state,
    mutations,
    actions,
    getters,
};
